// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".myFormDrawer .el-drawer__header {\n  margin-bottom: 0.625rem;\n  padding-bottom: 0.75rem;\n  color: #333;\n  border-bottom: 0.0625rem solid #e8e8e8;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
